import { render, staticRenderFns } from "./98.vue?vue&type=template&id=7a2c8e62&scoped=true&"
var script = {}
import style0 from "./98.vue?vue&type=style&index=0&id=7a2c8e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c8e62",
  null
  
)

export default component.exports